import Box from '@mui/material/Box'
import FileItem from 'components/Mobile/FileItem'
import { checkFileError } from 'utils/file'

import type { ProvidedProps } from 'hooks/useDocUpload'

function UploadItemList({ files, onDeleteFile }: Pick<ProvidedProps, 'files' | 'onDeleteFile'>) {
  const rows = files.map((file, idx) => {
    const { name, id } = file
    return (
      <FileItem
        key={id}
        filename={name}
        invalid={checkFileError(file).length > 0}
        onRemove={() => {
          onDeleteFile(idx)
        }}
      />
    )
  })

  return <Box>{rows}</Box>
}

export default UploadItemList
